/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {linkBankAccount} from '../api'

export const useMutationLinkBankAccount = createReactQueryMutationHook('linkBankAccount', linkBankAccount)
